import styled from 'styled-components'
import { FilterSelectUnstyled } from './unstyled'

export const FilterSelect = styled(FilterSelectUnstyled)`
  height: 40px;
  line-height: 40px;
  display: flex;

  label {
    color: ${props => (props.theme.colors || {}).regentGray || '#7F8FA4'};
    margin-right: 10px;
  }

  .form-select {
    width: 146px !important;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Filter/FilterSelect/index.js